import { useState, useEffect } from "react";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { toast } from "react-toastify";
import { studiesService } from "../service";

const nameRegex = /^[\p{L}0-9 _'-]+$/u;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const useCreateStudy = (onBack) => {
  const [loading, setLoading] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [editorState2, setEditorState2] = useState(EditorState.createEmpty());
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [errors, setErrors] = useState({ name: "", contact: "" });

  // Dynamic validation as user types
  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      name: !name.trim()
        ? prev.name
        : nameRegex.test(name.trim())
        ? ""
        : "Le nom contient des caractères non autorisés.",
    }));
  }, [name]);

  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      contact: !contact.trim()
        ? prev.contact
        : emailRegex.test(contact.trim())
        ? ""
        : "Veuillez entrer un email valide.",
    }));
  }, [contact]);

  // Validation before submit
  const validateInputs = () => {
    let newErrors = { name: "", contact: "" };
    let valid = true;

    if (!name.trim()) {
      newErrors.name = "Le nom de l'étude est requis.";
      valid = false;
    } else if (!nameRegex.test(name.trim())) {
      newErrors.name = "Le nom contient des caractères non autorisés.";
      valid = false;
    }

    if (!contact.trim()) {
      newErrors.contact = "Le contact de l'étude est requis.";
      valid = false;
    } else if (!emailRegex.test(contact.trim())) {
      newErrors.contact = "Veuillez entrer un email valide.";
      valid = false;
    }

    setErrors(newErrors);
    if (!valid)
      toast.error("Veuillez corriger les erreurs avant de soumettre.");
    return valid;
  };

  const handleSubmit = async () => {
    if (!validateInputs()) return;

    setLoading(true);
    setErrors({ name: "", contact: "" });

    const token = localStorage.getItem("access_token");
    if (!token) {
      toast.error("Vous devez être connecté pour créer une étude.");
      setLoading(false);
      return;
    }

    const abstractHtml = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    const protocolHtml = draftToHtml(
      convertToRaw(editorState2.getCurrentContent())
    );

    const studyData = {
      name: name.trim(),
      contact: contact.trim(),
      abstract: abstractHtml,
      protocol: protocolHtml,
      status: "active",
    };

    try {
      await studiesService.create(studyData, token);
      toast.success("Étude créée avec succès");

      // Reset fields
      setName("");
      setContact("");
      setEditorState(EditorState.createEmpty());
      setEditorState2(EditorState.createEmpty());

      setTimeout(() => {
        onBack && onBack();
      }, 1500);
    } catch (err) {
      console.error("Error creating study:", err);
      toast.error(
        err.response?.data?.detail ||
          err.message ||
          "Erreur lors de la création de l'étude."
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    name,
    setName,
    contact,
    setContact,
    editorState,
    setEditorState,
    editorState2,
    setEditorState2,
    loading,
    handleSubmit,
    errors,
  };
};
